import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a7d0f55"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation-tab-child_title-wrapper flex" }
const _hoisted_2 = { class: "navigation-tab-child_title-wrapper_notifications-container" }

import {NotificationBadge} from '@/logged/features/notifications';
    import {storeToRefs} from 'pinia';
    import {computed, toRefs, AnchorHTMLAttributes, PropType} from 'vue';
    import {useAsideMenu} from '../aside-menu.store';
    import {NavigationTab} from '../aside-menu.types';
    import {useDisplayMode} from '../stores';
    import {SvgIcon} from '@/logged/common/ui';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationTabItemChild',
  props: {
        /** Main tab object */
        tab: {
            type: Object as PropType<NavigationTab>,
            required: true,
        },
        isAnchoredBottom: {type: Boolean},
        isShownInADropdown: {type: Boolean},
    },
  setup(__props) {

const props = __props;

_useCssVars(_ctx => ({
  "6c7872cd": (hoverColor.value)
}))

    

    const {tab, isAnchoredBottom} = toRefs(props);
    const asideMenuStore = useAsideMenu();
    const displayModeStore = useDisplayMode();
    const {currentActiveRoute} = storeToRefs(asideMenuStore);
    const {isDisplayModeFull, isDisplayModeReduced} = storeToRefs(displayModeStore);

    const hoverColor = computed(() => tab.value.customHoverColor ?? `var(--joy-color-neutral-20)`);

    /** Dynamic component type */
    const getComponentType = computed<'div' | 'a'>(() => (tab.value.url ? 'a' : 'div'));
    const getComputedAttributes = computed<Partial<AnchorHTMLAttributes>>(() => {
        if (tab.value.url) {
            return {
                href: tab.value.url.href,
                ...(tab.value.url.blank && {
                    target: '_blank',
                    rel: 'noopener noreferer',
                }),
            };
        } else {
            return {};
        }
    });

    // Status
    const isActive = computed<boolean>(() => currentActiveRoute.value === tab.value.id);

    // - Events
    function handleClick() {
        if (tab.value.action && typeof tab.value.action === 'function') {
            tab.value.action();
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(getComponentType.value), _mergeProps({
    class: [{isActive: isActive.value, isFull: _unref(isDisplayModeFull), isReduced: _unref(isDisplayModeReduced), isShownInADropdown: __props.isShownInADropdown, isAnchoredBottom: _unref(isAnchoredBottom)}, "navigation-tab-child flex"],
    "data-testid": _unref(tab).id
  }, getComputedAttributes.value, {
    "aria-label": _unref(tab).title,
    onClick: handleClick
  }), {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_unref(tab).title), 1),
          (_unref(tab).icons?.altIcon && _unref(isDisplayModeReduced))
            ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                key: 0,
                class: "alt-icon",
                src: _unref(tab).icons.altIcon,
                name: "misc",
                "can-be-active": false,
                size: 14
              }, null, 8, ["src"]))
            : _createCommentVNode("", true),
          (_unref(tab).notificationsCount)
            ? (_openBlock(), _createBlock(_unref(NotificationBadge), {
                key: 1,
                count: _unref(tab).notificationsCount,
                offset: -2
              }, null, 8, ["count"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 16, ["class", "data-testid", "aria-label"]))
}
}

})